import { differenceInCalendarDays, fromUnixTime } from 'date-fns';

export function formatAvgDwellHours(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds <= 0) return '0m';
  if (seconds < 3600) {
    const minutes = Math.max(1, Math.round(seconds / 60));
    return `${minutes}m`;
  }
  const hours = seconds / 3600;
  return `${hours.toFixed(1)}h`;
}

export function formatLastActive(
  unixSeconds: number,
  now: Date = new Date(),
): string {
  if (!Number.isFinite(unixSeconds) || unixSeconds <= 0) return '—';
  const days = differenceInCalendarDays(now, fromUnixTime(unixSeconds));
  if (days <= 0) return '<1 day';
  if (days === 1) return '1 day';
  return `${days} days`;
}
